import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ActionsLogComponent from '../components/ActionsLogComponent';

import { getAllBuildings } from '../../Building/actionCreators';
import { getRoles } from '../../Messages/actions';
import { getAllPmcReducedData } from '../../PMC/actionCreators';
import { getUnitsWithContacts } from '../../Unit/actionCreators';
import {
  getActionsLog,
  getActionsLogNames,
  getLiveStreamItems,
  setActionsLogListParams,
} from '../actions';

import { filterObjectByKeyValue, getTodayCount } from '../../../utils';

const LIST_KEY = 'ActionsLog';

const ActionsLogContainer = (props) => {
  const { onGetActionsLog, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetActionsLog(queryParams);
  };
  return <ActionsLogComponent {...props} onExport={onExport} />;
};

ActionsLogContainer.propTypes = {
  onGetActionsLog: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const {
    carsonActivity: { actionsLog: items, actionsLogNames },
    lists,
    units,
    buildings,
    pmcs,
    getRoles: roles,
  } = state;
  const listParams = lists?.[LIST_KEY] ?? {};

  const seletedPmc = listParams?.pmc;
  const buildingsOptions = seletedPmc
    ? filterObjectByKeyValue(buildings, 'parent.id', +seletedPmc)
    : buildings;

  return {
    listKey: LIST_KEY,
    listParams,
    items,
    units,
    buildings,
    buildingsOptions,
    pmcs,
    actionsLogNames,
    roles,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    getAllPmcReducedData(dispatch);
    getAllBuildings(dispatch);
    getRoles(dispatch);
  },
  getItems: (queryParams) => {
    getActionsLog(dispatch, queryParams);
    getTodayCount(getActionsLog, dispatch, queryParams);
    getActionsLogNames(dispatch);
  },
  onGetActionsLog: (queryParams) => getActionsLog(dispatch, queryParams, true),
  getLiveStreamItems: (queryParams, items, isOnHold) =>
    getLiveStreamItems(dispatch, queryParams, items, isOnHold),
  setActionsLogListParams: (queryParams) =>
    setActionsLogListParams(dispatch, queryParams),
  getUnits: (buildingId) => getUnitsWithContacts(dispatch, buildingId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionsLogContainer);
